import { Anchor, Button } from '@mantine/core'

import { Link } from '@redwoodjs/router'

import { formatCooldown } from 'src/components/DriverAuth/smsSendLimit'
import ApplicationPhoneInput from 'src/pages/DriverApplicationPage/components/ApplicationPhoneInput'

interface PhoneStepProps {
  phone: string
  loading: boolean
  /** Waiting on the Cloudflare check before the code can be sent. */
  verifying?: boolean
  canSubmit: boolean
  cooldownSeconds: number
  onPhoneChange: (value: string) => void
  onSubmit: () => void
  /** Rendered as a real link below Continue when both are provided. */
  seeJobsLabel?: string
  seeJobsHref?: string
}

const PhoneStep = ({
  phone,
  loading,
  verifying = false,
  canSubmit,
  cooldownSeconds,
  onPhoneChange,
  onSubmit,
  seeJobsLabel,
  seeJobsHref,
}: PhoneStepProps) => {
  const blocked = cooldownSeconds > 0

  return (
    <div className="flex flex-col gap-4">
      <div className="text-center">
        <div className="text-2xl font-semibold text-doubleNickel-gray-900">
          Welcome
        </div>
        <div className="mt-1 text-sm text-doubleNickel-gray-600">
          Log in to continue your application.
        </div>
      </div>

      <ApplicationPhoneInput
        label="Phone number"
        phone={phone}
        error={undefined}
        handleChange={onPhoneChange}
        disabled={loading}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !loading && canSubmit && !blocked) onSubmit()
        }}
      />

      <Button
        fullWidth
        size="md"
        loading={loading}
        disabled={!canSubmit || blocked}
        onClick={onSubmit}
      >
        {blocked
          ? `Try again in ${formatCooldown(cooldownSeconds)}`
          : 'Continue'}
      </Button>

      {verifying && (
        <div
          role="status"
          className="text-center text-xs text-doubleNickel-gray-500"
        >
          Verifying your browser…
        </div>
      )}

      {seeJobsLabel && seeJobsHref && (
        <Anchor
          component={Link}
          to={seeJobsHref}
          className="text-center text-sm"
        >
          {seeJobsLabel}
        </Anchor>
      )}
    </div>
  )
}

export default PhoneStep
